import { ClerkResponse } from '../../typescript/Clerk';

export default async (clerkResponse: ClerkResponse, view: string): Promise<string[]> => {
  const handles = clerkResponse.product_data
    .filter((product) => product.handle !== 'gavekort') // temp - remove!
    .map((item) => item.handle);

  const items = await Promise.all(handles.map(async (handle) => {
    const response = await fetch(`/products/${handle}?view=${view}`);
    const html = await response.text();

    return html;
  }));

  return items;
};
